export default __webpack_public_path__ + "static/media/img_18.b343c99f.webp";